'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hoverTable = require('./hoverTable');

var _hoverTable2 = _interopRequireDefault(_hoverTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _hoverTable2.default;